export default __webpack_public_path__ + "46fdbd2d897f8824e63c8862af60b24c.woff";